function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 82 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".667",
  y: "23.5",
  width: "32",
  height: "3",
  rx: "1",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1.167",
  y: "29",
  width: "80.333",
  height: "13",
  rx: ".5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.646 34.146a.5.5 0 01.708 0L72 36.793l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1.167",
  y: "29",
  width: "80.333",
  height: "13",
  rx: ".5",
  stroke: "#D4D8E4"
})));